export default {
  index: [
    {
      path: '/processnode',
      component: resolve => require(['./processnodeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/process_node/_router.js